module.exports = __webpack_public_path__ + "img/login-page-credentials.27f25c31.png";